import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'cc4.seo.mail-upload-flight-document.card-title',
    defaultMessage: 'Forward us your flight documents',
  },
  cardDescriptionText: {
    id: 'cc4.seo.mail-upload-flight-document.card-description-text',
    defaultMessage:
      'To complete your claim is required the booking confirmation of your flight and -if available- the boarding pass and/or e-ticket.',
  },
  mailBoxImageTitle: {
    id: 'cc4.seo.mail-upload-flight-document.mailbox-title',
    defaultMessage: '1. Mailbox',
  },
  mailBoxImageDescription: {
    id: 'cc4.seo.mail-upload-flight-document.mailbox-descriprion',
    defaultMessage: 'Go to the mailbox used to book your flight.',
  },
  searchImageTitle: {
    id: 'cc4.seo.mail-upload-flight-document.search-title',
    defaultMessage: '2. Search',
  },
  searchImageDescription: {
    id: 'cc4.seo.mail-upload-flight-document.search-descriprion',
    defaultMessage:
      'Search for emails related to your flight typing the name of the airline.',
  },
  forwardImageTitle: {
    id: 'cc4.seo.mail-upload-flight-document.forward-title',
    defaultMessage: '3. Forward',
  },
  forwardImageDescription: {
    id: 'cc4.seo.mail-upload-flight-document.forward-descriprion',
    defaultMessage:
      'Forward the mails to our special upload email address bellow.',
  },
  sideInfoText: {
    id: 'cc4.seo.mail-upload-flight-document.side-info-text',
    defaultMessage:
      'Speed up by providing necessary documents. Up to <bold>80% faster</bold> claim processing!',
  },
  inputLabelTitle: {
    id: 'cc4.seo.mail-upload-flight-document.input-label-title',
    defaultMessage: 'Forward documents to:',
  },
  copyButtonTitle: {
    id: 'cc4.seo.mail-upload-flight-document.copy-button-title',
    defaultMessage: 'Copy address',
  },
  copiedButtonTitle: {
    id: 'cc4.seo.mail-upload-flight-document.copied-button-title',
    defaultMessage: 'Copied',
  },
  continueButtonText: {
    id: 'cc4.seo.mail-upload-flight-document.continue-button-text',
    defaultMessage: 'Continue',
  },
  backStepperText: {
    id: 'cc4.seo.mail-upload-flight-document.back-button-text',
    defaultMessage: 'Back',
  },
});
